import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useWindowSize } from '@react-hook/window-size';
import queryString from 'query-string';

import { useTheme } from '../../ThemeContext';

import Helmet from '../../components/Helmet';
import WelcomePanel from '../../components/WelcomePanel';
import LoadingData from '../../components/LoadingData';

import IMAGE_SIGN_BACKGROUND from '../../assets/Images/SignBackground.jpg';

import {
  Section,
  Wrapper,
  Content,
  Imagebox,
  Image,
  Footer,
} from './WelcomePage.style';

import { Breakpoints } from '../../assets/Variables.style';

const WelcomePage = ({ location, history }) => {
  const [width] = useWindowSize();
  const intl = useIntl();
  const theme = useTheme();
  const [email, setEmail] = useState(undefined);
  const [oobCode, setOobCode] = useState(undefined);
  const [mode, setMode] = useState(undefined);

  useEffect(() => {
    const params = queryString.parse(location.search);
    if (
      Object.keys(params).length > 0 &&
      params.email &&
      params.oobCode &&
      params.mode &&
      params.mode === 'welcome'
    ) {
      setEmail(params.email);
      setOobCode(params.oobCode);
      setMode(params.mode);
    } else history.push('/');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet
        title={intl.formatMessage({
          id: mode
            ? `PAGE_TITLE.${mode.toUpperCase()}`
            : `PAGE_TITLE.PLEASE_WAIT`,
        })}
      />
      <Section>
        <Wrapper theme={theme.sign.wrapper.default}>
          <Content>
            {mode === 'welcome' ? (
              <WelcomePanel email={email} oobCode={oobCode} />
            ) : (
              <LoadingData />
            )}
          </Content>
          <Footer theme={theme.sign.footer.default}>
            By signing in, you accept{' '}
            <a
              href='http://www.bine.world'
              target='_blank'
              rel='noopener noreferrer'
            >
              Privacy policy
            </a>{' '}
            <br />
            (including Use of Cookies and Other
            <br /> Technologies) and{' '}
            <a
              href='http://www.bine.world'
              target='_blank'
              rel='noopener noreferrer'
            >
              Terms of use
            </a>
          </Footer>
        </Wrapper>
        {width > Breakpoints.lg ? (
          <Wrapper theme={theme.sign.wrapper.alternative}>
            <Imagebox>
              <Image src={IMAGE_SIGN_BACKGROUND} alt='' />
            </Imagebox>
          </Wrapper>
        ) : (
          ''
        )}
      </Section>
    </>
  );
};

export default WelcomePage;
